import { c as _c } from "react/compiler-runtime";
import LinkButton from '@/components/ui/Link';
import { House, Film, Tv, Search } from 'lucide-react';
const MobileMenu = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <li><LinkButton variant="default" href="/" alt={"\u062E\u0627\u0646\u0647"} title={"\u062E\u0627\u0646\u0647"} className="flex flex-col items-center !p-0"><House size={22} strokeWidth={3} /></LinkButton></li>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li><LinkButton variant="default" href="/movies" alt={"\u0641\u06CC\u0644\u0645"} title={"\u0641\u06CC\u0644\u0645"} className="flex flex-col items-center !p-0"><Film size={20} strokeWidth={3} /></LinkButton></li>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li><LinkButton variant="default" href="/search" alt={"\u062C\u0633\u062A\u0648\u062C\u0648"} title={"\u062C\u0633\u062A\u0648\u062C\u0648"} className="flex flex-col items-center !p-0"><Search size={20} strokeWidth={3} /></LinkButton></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="fixed z-50 -bottom-1 w-full h-16 flex md:hidden flex-col lg:flex-row items-center justify-between border-t border-gray-200 dark:border-gray-700 backdrop-blur-xl bg-secondary/60 px-4 gap-4 rounded-ss-xl rounded-se-xl"><nav className="w-full flex items-center h-full "><ul className="w-full flex items-center justify-around">{t0}{t1}{t2}<li><LinkButton variant="default" href="/series" alt={"\u0633\u0631\u06CC\u0627\u0644"} title={"\u0633\u0631\u06CC\u0627\u0644"} className="flex flex-col items-center !p-0"><Tv size={20} strokeWidth={3} /></LinkButton></li></ul></nav></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default MobileMenu;